<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "texts",
    cardSetLink: "texts",
    item: null,
    fields: [
      {
            col:' col-12 col-md-12',
            key: "key",
            label: "Ключ",
            type: "field",
            textType: "text",
      },
      {
          col:' col-12 col-md-12',
          key: "group",
          label: "Группа",
          type: "static_radio",
          items: [
              { id: 'button', title: "Кнопки" },
              { id: 'label', title: "Заголовки" },
              { id: 'placeholder', title: "Заполнитель" },
              { id: 'info', title: "Ифно" },
          ],
      },
      {
        label: "Название",
        key: "title",
        type: "field",
        textType: "text", 
        isMultiLang:true
    },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
   
    },
  },
};
</script>
<style>
</style>
